const ScreenHelper = {
	triggerCallbackAtScrollEnd(e: any, callback: undefined | (() => void)): void {
		const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
		if (bottom) callback?.();
	}
};

export default ScreenHelper;
